// tslint:disable: quotemark
export const versionJson={
  "version": "3.3.5",
  "buildDate": "2024-07-09T07:14:25.748Z",
  "git": {
    "tag": "v3.3.5",
    "refName": "v3.3.5",
    "sha": "8c37340c798c81da43d776a91da6fb7b2b4068a6"
  }
};